import { Injectable } from '@angular/core';
import { AnalyticsInterface } from '@models/analytics';
import { ResultRegisterOptions } from '@modules/register/models/register';

@Injectable({
  providedIn: 'root'
})
export class ResultRegisterHelperService {

  private _options: Partial<ResultRegisterOptions>;
  private _analytics: Partial<AnalyticsInterface>;

  constructor() { }

  set analytics(analytics: Partial<AnalyticsInterface>) {
    this._analytics = analytics;
  }

  get analytics(): Partial<AnalyticsInterface> {
    return this._analytics;
  }

  set options(opts: Partial<ResultRegisterOptions>) {
    this._options = opts;
  }

  get options(): Partial<ResultRegisterOptions> {
    return this._options;
  }

}
